/* Akashi Coming Soon: celebration layer (gold dust, confetti, fireworks) + countdown */
(function(){
 if(matchMedia('(prefers-reduced-motion:reduce)').matches)return;
 var ds=(document.querySelector('.cs')||{dataset:{}}).dataset,ec=ds.confetti!=='false',ef=ds.fireworks!=='false',ed=ds.dust!=='false';
 var c=document.getElementById('fx'),x=c.getContext('2d'),W,H,D=Math.min(devicePixelRatio||1,2),sm=innerWidth<720,R=function(a,b){return a+Math.random()*(b-a)};
 function size(){W=innerWidth;H=innerHeight;c.width=W*D;c.height=H*D;x.setTransform(D,0,0,D,0,0)}size();addEventListener('resize',size);

 var g=document.createElement('canvas');g.width=g.height=32;var gx=g.getContext('2d'),gr=gx.createRadialGradient(16,16,0,16,16,16);
 gr.addColorStop(0,'rgba(255,222,140,1)');gr.addColorStop(.3,'rgba(232,170,60,.6)');gr.addColorStop(1,'rgba(232,170,60,0)');gx.fillStyle=gr;gx.fillRect(0,0,32,32);

 var dust=[],i;for(i=0;i<(ed?(sm?24:48):0);i++)dust.push({x:R(0,W),y:R(0,H),r:R(4,11),vy:R(.12,.4),ph:R(0,6.28),sp:R(.6,1.6)});

 var cc=['#d9a95a','#e9c98a','#c9566b','#1f7a5a','#7a1e2a','#f1c7b3'],conf=[];
 function piece(px,py,b,vx,vy){return{x:px,y:py,w:R(5,8),h:R(8,13),c:cc[Math.random()*cc.length|0],vx:vx,vy:vy,rot:R(0,6.28),vr:R(-.12,.12),ph:R(0,6.28),a:1}}
 function cannon(){var n=sm?24:46,s;for(s=0;s<n;s++){conf.push(piece(0,H,1,R(3,11),-R(10,19)));conf.push(piece(W,H,1,-R(3,11),-R(10,19)))}}
 if(ec)setTimeout(cannon,500);

 var pal=['#d49a2a','#e6b23c','#c9566b','#1f8a62','#b8741f'],rk=[],sp=[],nextL=1400;
 function launch(){var tx=R(.12,.88)*W,ty=R(.1,.46)*H;rk.push({x:tx+R(-50,50),y:H+8,tx:tx,ty:ty,vy:-(H-ty)/36,c:pal[Math.random()*pal.length|0]})}
 function boom(r){var n=sm?44:84,k,a,s;for(k=0;k<n;k++){a=k/n*6.283+R(-.04,.04);s=R(2.2,4.8);sp.push({x:r.x,y:r.y,vx:Math.cos(a)*s,vy:Math.sin(a)*s,l:1,d:R(.012,.02),c:Math.random()<.7?r.c:'#f3d58a',w:R(1.2,2.2)})}}

 var t0=0;
 function loop(t){
  x.clearRect(0,0,W,H);
  var k,p;
  for(k=0;k<dust.length;k++){p=dust[k];p.y-=p.vy;p.x+=Math.sin(t/1000*p.sp+p.ph)*.25;if(p.y<-12){p.y=H+12;p.x=R(0,W)}
   x.globalAlpha=.25+.55*Math.abs(Math.sin(t/1000*p.sp+p.ph));x.drawImage(g,p.x-p.r,p.y-p.r,p.r*2,p.r*2)}
  x.globalAlpha=1;

  if(ef&&t>nextL){launch();if(Math.random()<.3)setTimeout(launch,250);nextL=t+R(2200,3800)}
  for(k=rk.length-1;k>=0;k--){p=rk[k];x.strokeStyle=p.c;x.globalAlpha=.9;x.lineWidth=2;x.beginPath();x.moveTo(p.x,p.y-p.vy*3);x.lineTo(p.x,p.y);x.stroke();
   p.y+=p.vy;p.vy*=.985;if(p.y<=p.ty||Math.abs(p.vy)<2.2){boom(p);rk.splice(k,1)}}
  for(k=sp.length-1;k>=0;k--){p=sp[k];p.vx*=.972;p.vy=p.vy*.972+.045;p.x+=p.vx;p.y+=p.vy;p.l-=p.d;
   if(p.l<=0){sp.splice(k,1);continue}
   x.globalAlpha=p.l*(Math.random()>.88?.45:1);x.strokeStyle=p.c;x.lineWidth=p.w;x.beginPath();x.moveTo(p.x-p.vx*1.6,p.y-p.vy*1.6);x.lineTo(p.x,p.y);x.stroke()}

  if(ec&&conf.length<(sm?16:30)&&Math.random()<.08)conf.push(piece(R(0,W),-20,0,R(-.4,.4),R(.8,1.6)));
  for(k=conf.length-1;k>=0;k--){p=conf[k];p.vy+=.14;if(p.vy>2.1)p.vy*=.9;p.vx*=.975;p.x+=p.vx+Math.sin(p.ph)*.4;p.y+=p.vy;p.rot+=p.vr;p.ph+=.07;
   if(p.y>H+30){conf.splice(k,1);continue}
   x.save();x.translate(p.x,p.y);x.rotate(p.rot);x.scale(1,Math.cos(p.ph));x.globalAlpha=.92;x.fillStyle=p.c;x.fillRect(-p.w/2,-p.h/2,p.w,p.h);x.restore()}
  x.globalAlpha=1;requestAnimationFrame(loop)}
 requestAnimationFrame(loop);
})();

// Launch: 09 November 2026, 10:00 AM IST
var cs=document.querySelector('.cs')||{dataset:{}},launch=new Date(cs.dataset.launch||'2026-11-09T10:00:00+05:30').getTime();
function tick(){
 var d=Math.max(0,launch-Date.now()),v={d:Math.floor(d/864e5),h:Math.floor(d/36e5)%24,m:Math.floor(d/6e4)%60,s:Math.floor(d/1e3)%60};
 for(var k in v)document.getElementById(k).textContent=String(v[k]).padStart(2,'0');
 if(d===0)document.getElementById('tt').textContent=cs.dataset.live||'We Are Live';
}
tick();setInterval(tick,1000);
